import { useTolgee, useTranslate } from '@tolgee/react';
import { useAuth } from 'lincd-auth/hooks/useAuth.js';
import { Player } from 'lincd-irlcg/shapes/Player';
import { cl } from 'lincd/utils/ClassNames';
import * as React from 'react';
import { AVAILABLE_LANGUAGES } from '../../utils/tolgee.js';
import style from './SwitchLanguage.module.css';

interface SwitchLanguageProps {
  className?: string;
}

export const SwitchLanguage = ({ className }: SwitchLanguageProps) => {
  const tolgee = useTolgee();
  let { t } = useTranslate();
  const [language, setLanguage] = React.useState(tolgee.getLanguage());
  const auth = useAuth();
  const user = auth.user;

  const onChangeLanguage = async (e) => {
    let newLang = e.target.value;
    console.log('changing language to: ', newLang);
    setLanguage(newLang);

    //store language preference in the user profile
    if (user) {
      await Player.update(user, {
        languagePreference: newLang,
      });
    }

    tolgee.changeLanguage(newLang).then(() => {
      console.log('language updated to: ' + tolgee.getLanguage());
    });
  };

  return (
    <div className={cl(style.root, className)}>
      {t('word.language', 'Language')}
      {': '}
      <select onChange={onChangeLanguage} value={language}>
        {AVAILABLE_LANGUAGES.map((lang) => {
          return (
            <option key={lang} value={lang}>
              {lang}
            </option>
          );
        })}
      </select>
    </div>
  );
};
